import { Title } from "components/common";
import { renderQuillHtml } from "configs/utils";
import {
  useGetShortQuestionAnswerMutation,
  useQuestionAnswerMutation,
} from "features/script/api";
import { useDispatch } from "react-redux";
import { setQuizData } from "store/quizSlice";
import QuestionAnswerDetails from "./questionAnswerDetails";
import QuestionOptions from "./questionOptions";
import QuizQuestionActions from "./quizQuestionActions";
import UserActions from "./userActions";
import ImageSlider from "components/common/slider/slider";
import TextEditor from "components/common/textEditor/textEditor";
import { useState } from "react";

const QuestionItem = ({
  question,
  setSelectedQuestion,
  quizDetails,
  selectedQuestion,
  showQuizActions = true,
  scriptId,
  resultPage,
}) => {
  const dispatch = useDispatch();

  const [getQuestionAnswer, _] = useQuestionAnswerMutation();
  const [getShortAnswer] = useGetShortQuestionAnswerMutation();

  const [shortAnswer, setShortAnswer] = useState(null);

  const onUserAction = (questionDetails) => {
    let tempQuestionsList = JSON.parse(
      JSON.stringify(quizDetails?.questionsList)
    );
    tempQuestionsList[selectedQuestion] = {
      ...tempQuestionsList[selectedQuestion],
      questionDetails: questionDetails,
    };
    dispatch(setQuizData({ questionsList: tempQuestionsList }));
  };

  const renderTitle = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          marginBottom: "-12px",
        }}
      >
        <UserActions
          question={question}
          scriptId={scriptId}
          onUserAction={onUserAction}
        />
      </div>
    );
  };

  const onQuestionSubmit = async () => {
    if (question?.isShortQuestion) {
      const response = await getShortAnswer({
        userAnswer: shortAnswer
          .replace(/<[^>]*>/g, "") // Remove HTML tags
          .replace(/&nbsp;/g, " ") // Replace &nbsp; with space
          .trim(),
        questionId: question?.questionId,
      });
      if (response) {
        if (response?.error) {
        } else if (response?.data) {
          let tempQuestionsList = JSON.parse(
            JSON.stringify(quizDetails?.questionsList)
          );
          tempQuestionsList[selectedQuestion].answer =
            response?.data?.correctAnswer?.[0];
          tempQuestionsList[selectedQuestion].userAnswer = shortAnswer;
          tempQuestionsList[selectedQuestion].isCorrectSelected =
            response?.data?.iscorrect;

          dispatch(setQuizData({ questionsList: tempQuestionsList }));
        }
      }
    } else {
      const response = await getQuestionAnswer({
        questionId: question?.questionId,
      });

      if (response) {
        if (response?.error) {
        } else if (response?.data) {
          let tempQuestionsList = JSON.parse(
            JSON.stringify(quizDetails?.questionsList)
          );
          tempQuestionsList[selectedQuestion].answer = response?.data;
          dispatch(setQuizData({ questionsList: tempQuestionsList }));
        }
      }
    }
  };

  const onSkipQuestion = () => {
    const tempQuestionsList = JSON.parse(
      JSON.stringify(quizDetails?.questionsList)
    );
    tempQuestionsList[selectedQuestion].skipped = true;
    dispatch(setQuizData({ questionsList: tempQuestionsList }));
    setSelectedQuestion((prev) => prev + 1);
  };

  const onOptionSelection = (item) => {
    const tempQuestionsList = JSON.parse(
      JSON.stringify(quizDetails?.questionsList)
    );
    tempQuestionsList[selectedQuestion].optionSelected = item;
    const today = new Date();
    today.setUTCHours(0, 0, 0, 0);
    tempQuestionsList[selectedQuestion].answeredAt = today;

    dispatch(setQuizData({ questionsList: tempQuestionsList }));
  };

  const getQuestionAnswerCharCode = () => {
    if (question?.isShortQuestion) {
      return question?.answer;
    }
    const index = question?.options?.findIndex(
      (e) => e?.answerId == question?.answer?.[0]
    );
    if (index != -1) {
      return String.fromCharCode(65 + index);
    } else return "-";
  };

  return (
    <div style={{ margin: "1%" }}>
      {renderTitle()}
      <div
        style={{
          // flex: 1,
          overflow: "auto",
          ...(resultPage ? {} : { maxHeight: "70vh" }), // Adjust this value as needed
          marginTop: "16px",
        }}
      >
        <Title level={4}>
          {renderQuillHtml(`<p>
              <span style="font-weight: bold; font-size: 18px;">Question:</span>
              <span style="display: inline;">${question?.description}</span>
            </p>`)}
        </Title>

        {question?.isShortQuestion ? (
          question?.userAnswer ? (
            <>
              {renderQuillHtml(`<p>
              <span style="font-weight: bold; font-size: 18px;color: red">Your Answer:</span>
              <span style="display: inline; color: red">${question?.userAnswer}</span>
              </p>`)}
            </>
          ) : (
            <div style={{ marginTop: "2%" }}>
              <Title level={4}>Answer</Title>
              <TextEditor
                key={"shortAnswer"}
                placeholder={"Enter answer"}
                value={shortAnswer}
                onChange={(value) => {
                  setShortAnswer(value);
                }}
                editorHeight={200}
              />
            </div>
          )
        ) : (
          <QuestionOptions
            options={question?.options}
            answer={question?.answer}
            isAnswered={!!question?.answer}
            optionSelected={question?.optionSelected}
            onOptionSelection={onOptionSelection}
            resultPage={resultPage}
          />
        )}

        {question?.images?.[0] && (
          <div>
            <Title level={4}>Image</Title>
            <ImageSlider
              data={[{ type: "image", url: question?.images?.[0] }]}
              itemToShow={1}
              itemHeight={150}
              itemWidth={150}
            />
          </div>
        )}
        {resultPage && (
          <Title level={4}>Question ID: {question?.questionId}</Title>
        )}
        {!!question?.answer && (
          <QuestionAnswerDetails
            answer={getQuestionAnswerCharCode()}
            explanation={question?.explanation}
            additionalInfo={question?.additionalInfo}
            isCorrectSelected={
              question?.isCorrectSelected ||
              question?.answer?.includes(question?.optionSelected)
            }
          />
        )}
      </div>
      {showQuizActions && (
        <QuizQuestionActions
          onSkipQuestion={onSkipQuestion}
          onQuestionSubmit={onQuestionSubmit}
          disableSubmit={
            question?.isShortQuestion && !question?.answer
              ? !shortAnswer
              : !question?.optionSelected || !!question?.answer
          }
          disableNext={!question?.answer && !question?.skipped}
          showNext={quizDetails?.questionsList?.length - 1 > selectedQuestion}
          onNext={() => setSelectedQuestion((prev) => prev + 1)}
          questionId={question?.questionId}
          disableSkip={!!question?.answer}
        />
      )}
    </div>
  );
};

export default QuestionItem;
